import type {
  CreateAdjustmentReasonsAPIRequest,
  CreateAdjustmentReasonsAPIResponse,
  CreateAdjustmentRequest,
  CreateAdjustmentResponse
} from '@library/types/members/memberAdjustments';
import type { ComboboxOptions } from '@library/components/selects';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { defaultHeaders } from '@bo-constants/apiHeaders';
import { transformAdjustmentReasons } from '@bo-utils/members/memberAdjustments';

const { member, memberSupport } = apiPaths;

export const memberAdjustmentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMemberPromotionReasons: build.query<
      ComboboxOptions,
      CreateAdjustmentReasonsAPIRequest
    >({
      query: ({ reasonType }) => ({
        url: `${memberSupport}reasons`,
        method: 'GET',
        headers: defaultHeaders,
        params: {
          reason_type: reasonType
        }
      }),
      transformResponse: (
        response: CreateAdjustmentReasonsAPIResponse | undefined
      ) => {
        return transformAdjustmentReasons({ response });
      }
    }),
    createMemberAdjustment: build.mutation<
      CreateAdjustmentResponse,
      CreateAdjustmentRequest
    >({
      query: ({
        adjustmentAmountInCents,
        adjustmentReasonId,
        isPromo,
        memberId
      }) => ({
        url: `${member}/${memberId}/adjustments`,
        method: 'POST',
        body: {
          amount_cents: adjustmentAmountInCents,
          reason_id: adjustmentReasonId,
          is_promo: isPromo
        },
        headers: defaultHeaders
      }),
      invalidatesTags: ['Member']
    })
  })
});

export const {
  useCreateMemberAdjustmentMutation,
  useGetMemberPromotionReasonsQuery
} = memberAdjustmentsApi;
